import React from "react";
import { Switch, Route } from "react-router-dom";
import { NoMatch } from "../src/pages/NoMatch";

import { Loading as _Loading } from "../src/pages/Loading";
import { Maintenance as _Maintenance } from "../src/pages/Maintenance";
import { NoMatch as _NoMatch } from "../src/pages/NoMatch";
import { NotAuthorized as _NotAuthorized } from "../src/pages/NotAuthorized";
import { AboutCompany as _about_AboutCompany } from "../src/pages/about/AboutCompany";
import { CookiePolicy as _about_CookiePolicy } from "../src/pages/about/CookiePolicy";
import { PrivacyPolicy as _about_PrivacyPolicy } from "../src/pages/about/PrivacyPolicy";
import { TermsOfUse as _about_TermsOfUse } from "../src/pages/about/TermsOfUse";
import { AgencyDetails as _admin_agency_AgencyDetails } from "../src/pages/admin/agency/AgencyDetails";
import { WarehouseCalendar as _admin_agency_WarehouseCalendar } from "../src/pages/admin/agency/WarehouseCalendar";
import { ForgetPassword as _admin_auth_ForgetPassword } from "../src/pages/admin/auth/ForgetPassword";
import { Login as _admin_auth_Login } from "../src/pages/admin/auth/Login";
import { ResetPassword as _admin_auth_ResetPassword } from "../src/pages/admin/auth/ResetPassword";
import { AllBookings as _admin_booking_AllBookings } from "../src/pages/admin/booking/AllBookings";
import { BookingCreate as _admin_booking_BookingCreate } from "../src/pages/admin/booking/BookingCreate";
import { BookingCreateComplete as _admin_booking_BookingCreateComplete } from "../src/pages/admin/booking/BookingCreateComplete";
import { BookingDetails as _admin_booking_BookingDetails } from "../src/pages/admin/booking/BookingDetails";
import { BookingInquiries as _admin_booking_BookingInquiries } from "../src/pages/admin/booking/BookingInquiries";
import { CanceledBookings as _admin_booking_CanceledBookings } from "../src/pages/admin/booking/CanceledBookings";
import { CurrentBookingsAfterDeparture as _admin_booking_CurrentBookingsAfterDeparture } from "../src/pages/admin/booking/CurrentBookingsAfterDeparture";
import { CurrentBookingsBeforeDeparture as _admin_booking_CurrentBookingsBeforeDeparture } from "../src/pages/admin/booking/CurrentBookingsBeforeDeparture";
import { CustomsCommodityExport as _admin_booking_CustomsCommodityExport } from "../src/pages/admin/booking/CustomsCommodityExport";
import { CustomsInstruction as _admin_booking_CustomsInstruction } from "../src/pages/admin/booking/CustomsInstruction";
import { CustomsRequestDetails as _admin_booking_CustomsRequestDetails } from "../src/pages/admin/booking/CustomsRequestDetails";
import { Dashboard as _admin_booking_Dashboard } from "../src/pages/admin/booking/Dashboard";
import { DeliveryInstruction as _admin_booking_DeliveryInstruction } from "../src/pages/admin/booking/DeliveryInstruction";
import { DeliveryRequestDetails as _admin_booking_DeliveryRequestDetails } from "../src/pages/admin/booking/DeliveryRequestDetails";
import { DeliveryRequests as _admin_booking_DeliveryRequests } from "../src/pages/admin/booking/DeliveryRequests";
import { ExportPreAlert as _admin_booking_ExportPreAlert } from "../src/pages/admin/booking/ExportPreAlert";
import { ExportSeaWaybill as _admin_booking_ExportSeaWaybill } from "../src/pages/admin/booking/ExportSeaWaybill";
import { InquiryDetails as _admin_booking_InquiryDetails } from "../src/pages/admin/booking/InquiryDetails";
import { InvoiceDetail as _admin_booking_InvoiceDetail } from "../src/pages/admin/booking/InvoiceDetail";
import { PastBookings as _admin_booking_PastBookings } from "../src/pages/admin/booking/PastBookings";
import { PaymentSlipDetails as _admin_booking_PaymentSlipDetails } from "../src/pages/admin/booking/PaymentSlipDetails";
import { PrintBarcode as _admin_booking_PrintBarcode } from "../src/pages/admin/booking/PrintBarcode";
import { PrintCustomsRequestLog as _admin_booking_PrintCustomsRequestLog } from "../src/pages/admin/booking/PrintCustomsRequestLog";
import { PrintDeliveryRequestLog as _admin_booking_PrintDeliveryRequestLog } from "../src/pages/admin/booking/PrintDeliveryRequestLog";
import { PrintInvoiceLog as _admin_booking_PrintInvoiceLog } from "../src/pages/admin/booking/PrintInvoiceLog";
import { PrintPaymentSlipLog as _admin_booking_PrintPaymentSlipLog } from "../src/pages/admin/booking/PrintPaymentSlipLog";
import { PrintPreAlertLog as _admin_booking_PrintPreAlertLog } from "../src/pages/admin/booking/PrintPreAlertLog";
import { PrintSeaWaybillLog as _admin_booking_PrintSeaWaybillLog } from "../src/pages/admin/booking/PrintSeaWaybillLog";
import { InvoiceList as _admin_invoice_InvoiceList } from "../src/pages/admin/invoice/InvoiceList";
import { PaymentSlipBatchDetails as _admin_invoice_PaymentSlipBatchDetails } from "../src/pages/admin/invoice/PaymentSlipBatchDetails";
import { PaymentSlipBatchList as _admin_invoice_PaymentSlipBatchList } from "../src/pages/admin/invoice/PaymentSlipBatchList";
import { PaymentSlipList as _admin_invoice_PaymentSlipList } from "../src/pages/admin/invoice/PaymentSlipList";
import { CompletionRequests as _admin_members_CompletionRequests } from "../src/pages/admin/members/CompletionRequests";
import { MemberDetails as _admin_members_MemberDetails } from "../src/pages/admin/members/MemberDetails";
import { Members as _admin_members_Members } from "../src/pages/admin/members/Members";
import { MembershipFormDetails as _admin_members_MembershipFormDetails } from "../src/pages/admin/members/MembershipFormDetails";
import { MembershipForms as _admin_members_MembershipForms } from "../src/pages/admin/members/MembershipForms";
import { Users as _admin_members_Users } from "../src/pages/admin/members/Users";
import { AddStaff as _admin_staffs_AddStaff } from "../src/pages/admin/staffs/AddStaff";
import { Password as _admin_staffs_Password } from "../src/pages/admin/staffs/Password";
import { Profile as _admin_staffs_Profile } from "../src/pages/admin/staffs/Profile";
import { Staff as _admin_staffs_Staff } from "../src/pages/admin/staffs/Staff";
import { Staffs as _admin_staffs_Staffs } from "../src/pages/admin/staffs/Staffs";
import { Agencies as _admin_widgets_Agencies } from "../src/pages/admin/widgets/Agencies";
import { AgencyDetails as _admin_widgets_AgencyDetails } from "../src/pages/admin/widgets/AgencyDetails";
import { CargoTracking as _admin_widgets_CargoTracking } from "../src/pages/admin/widgets/CargoTracking";
import { CargoTrackingDetails as _admin_widgets_CargoTrackingDetails } from "../src/pages/admin/widgets/CargoTrackingDetails";
import { ExchangeCalendar as _admin_widgets_ExchangeCalendar } from "../src/pages/admin/widgets/ExchangeCalendar";
import { PartnerDetails as _admin_widgets_PartnerDetails } from "../src/pages/admin/widgets/PartnerDetails";
import { Partners as _admin_widgets_Partners } from "../src/pages/admin/widgets/Partners";
import { RoutePlanDetail as _admin_widgets_RoutePlanDetail } from "../src/pages/admin/widgets/RoutePlanDetail";
import { RoutePlanManagement as _admin_widgets_RoutePlanManagement } from "../src/pages/admin/widgets/RoutePlanManagement";
import { VesselSchedule as _admin_widgets_VesselSchedule } from "../src/pages/admin/widgets/VesselSchedule";
import { WarehouseCalendar as _admin_widgets_WarehouseCalendar } from "../src/pages/admin/widgets/WarehouseCalendar";
import { ConfirmEmail as _auth_ConfirmEmail } from "../src/pages/auth/ConfirmEmail";
import { CreateAccount as _auth_CreateAccount } from "../src/pages/auth/CreateAccount";
import { CreateAccountVerifyEmail as _auth_CreateAccountVerifyEmail } from "../src/pages/auth/CreateAccountVerifyEmail";
import { ForgetPassword as _auth_ForgetPassword } from "../src/pages/auth/ForgetPassword";
import { Login as _auth_Login } from "../src/pages/auth/Login";
import { ResendEmail as _auth_ResendEmail } from "../src/pages/auth/ResendEmail";
import { ResetPassword as _auth_ResetPassword } from "../src/pages/auth/ResetPassword";
import { About as _dev_About } from "../src/pages/dev/About";
import { Accounts as _dev_Accounts } from "../src/pages/dev/Accounts";
import { E2eMail as _dev_E2eMail } from "../src/pages/dev/E2eMail";
import { FCProxy as _dev_FCProxy } from "../src/pages/dev/FCProxy";
import { Impersonate as _dev_Impersonate } from "../src/pages/dev/Impersonate";
import { MockKikan as _dev_MockKikan } from "../src/pages/dev/MockKikan";
import { NextForm as _dev_NextForm } from "../src/pages/dev/NextForm";
import { Svgs as _dev_Svgs } from "../src/pages/dev/Svgs";
import { Theme as _dev_Theme } from "../src/pages/dev/Theme";
import { Urls as _dev_Urls } from "../src/pages/dev/Urls";
import { TestBadResponse as _dev_tests_TestBadResponse } from "../src/pages/dev/tests/TestBadResponse";
import { TestError as _dev_tests_TestError } from "../src/pages/dev/tests/TestError";
import { TestNextBadResponse as _dev_tests_TestNextBadResponse } from "../src/pages/dev/tests/TestNextBadResponse";
import { TestPost400 as _dev_tests_TestPost400 } from "../src/pages/dev/tests/TestPost400";
import { TestQingdaoRouteAlert as _dev_tests_TestQingdaoRouteAlert } from "../src/pages/dev/tests/TestQingdaoRouteAlert";
import { TestStatusError404 as _dev_tests_TestStatusError404 } from "../src/pages/dev/tests/TestStatusError404";
import { TestStatusError500 as _dev_tests_TestStatusError500 } from "../src/pages/dev/tests/TestStatusError500";
import { TestTextBox as _dev_tests_TestTextBox } from "../src/pages/dev/tests/TestTextBox";
import { TestTypeError as _dev_tests_TestTypeError } from "../src/pages/dev/tests/TestTypeError";
import { CustomsRequestDownloadPdf as _external_CustomsRequestDownloadPdf } from "../src/pages/external/CustomsRequestDownloadPdf";
import { DeliveryRequestDownloadPdf as _external_DeliveryRequestDownloadPdf } from "../src/pages/external/DeliveryRequestDownloadPdf";
import { DeliveryRequestReceiptUpload as _external_DeliveryRequestReceiptUpload } from "../src/pages/external/DeliveryRequestReceiptUpload";
import { PrintCustomsRequestLog as _external_PrintCustomsRequestLog } from "../src/pages/external/PrintCustomsRequestLog";
import { PrintDeliveryRequestLog as _external_PrintDeliveryRequestLog } from "../src/pages/external/PrintDeliveryRequestLog";
import { Profile as _settings_AccountManager_Profile } from "../src/pages/settings/AccountManager/Profile";
import { Security as _settings_AccountManager_Security } from "../src/pages/settings/AccountManager/Security";
import { Checklist as _settings_Membership_Checklist } from "../src/pages/settings/Membership/Checklist";
import { CompanyInfo as _settings_Membership_CompanyInfo } from "../src/pages/settings/Membership/CompanyInfo";
import { DelegationForm as _settings_Membership_DelegationForm } from "../src/pages/settings/Membership/DelegationForm";
import { PrincipalInfo as _settings_Membership_PrincipalInfo } from "../src/pages/settings/Membership/PrincipalInfo";
import { AddBlanketInsurance as _utilities_BlanketInsurance_AddBlanketInsurance } from "../src/pages/utilities/BlanketInsurance/AddBlanketInsurance";
import { BlanketInsuranceDetails as _utilities_BlanketInsurance_BlanketInsuranceDetails } from "../src/pages/utilities/BlanketInsurance/BlanketInsuranceDetails";
import { BlanketInsurances as _utilities_BlanketInsurance_BlanketInsurances } from "../src/pages/utilities/BlanketInsurance/BlanketInsurances";
import { Complete as _utilities_BookingInquiry_Complete } from "../src/pages/utilities/BookingInquiry/Complete";
import { InquiryForm as _utilities_BookingInquiry_InquiryForm } from "../src/pages/utilities/BookingInquiry/InquiryForm";
import { MobileCautions as _utilities_BookingInquiry_MobileCautions } from "../src/pages/utilities/BookingInquiry/MobileCautions";
import { BookingInquiryHistory as _utilities_Bookings_BookingInquiryHistory } from "../src/pages/utilities/Bookings/BookingInquiryHistory";
import { BookingInquiryHistoryDetails as _utilities_Bookings_BookingInquiryHistoryDetails } from "../src/pages/utilities/Bookings/BookingInquiryHistoryDetails";
import { BookingInquiryLogs as _utilities_Bookings_BookingInquiryLogs } from "../src/pages/utilities/Bookings/BookingInquiryLogs";
import { CurrentBookingDetails as _utilities_Bookings_CurrentBookingDetails } from "../src/pages/utilities/Bookings/CurrentBookingDetails";
import { CurrentBookings as _utilities_Bookings_CurrentBookings } from "../src/pages/utilities/Bookings/CurrentBookings";
import { CustomsInstruction as _utilities_Bookings_CustomsInstruction } from "../src/pages/utilities/Bookings/CustomsInstruction";
import { CustomsInstructionList as _utilities_Bookings_CustomsInstructionList } from "../src/pages/utilities/Bookings/CustomsInstructionList";
import { DeliveryGuidance as _utilities_Bookings_DeliveryGuidance } from "../src/pages/utilities/Bookings/DeliveryGuidance";
import { DeliveryInstruction as _utilities_Bookings_DeliveryInstruction } from "../src/pages/utilities/Bookings/DeliveryInstruction";
import { DeliveryInstructionList as _utilities_Bookings_DeliveryInstructionList } from "../src/pages/utilities/Bookings/DeliveryInstructionList";
import { ExportArrivalNotice as _utilities_Bookings_ExportArrivalNotice } from "../src/pages/utilities/Bookings/ExportArrivalNotice";
import { ExportPreAlert as _utilities_Bookings_ExportPreAlert } from "../src/pages/utilities/Bookings/ExportPreAlert";
import { ExportSeaWaybill as _utilities_Bookings_ExportSeaWaybill } from "../src/pages/utilities/Bookings/ExportSeaWaybill";
import { PastBookingDetails as _utilities_Bookings_PastBookingDetails } from "../src/pages/utilities/Bookings/PastBookingDetails";
import { PastBookings as _utilities_Bookings_PastBookings } from "../src/pages/utilities/Bookings/PastBookings";
import { PrintArrivalNoticeLogs as _utilities_Bookings_PrintArrivalNoticeLogs } from "../src/pages/utilities/Bookings/PrintArrivalNoticeLogs";
import { PrintBarcode as _utilities_Bookings_PrintBarcode } from "../src/pages/utilities/Bookings/PrintBarcode";
import { PrintCurrentBookingDetails as _utilities_Bookings_PrintCurrentBookingDetails } from "../src/pages/utilities/Bookings/PrintCurrentBookingDetails";
import { PrintPreAlertLog as _utilities_Bookings_PrintPreAlertLog } from "../src/pages/utilities/Bookings/PrintPreAlertLog";
import { PrintSeaWaybillLog as _utilities_Bookings_PrintSeaWaybillLog } from "../src/pages/utilities/Bookings/PrintSeaWaybillLog";
import { CargoTracking as _utilities_CargoTracking_CargoTracking } from "../src/pages/utilities/CargoTracking/CargoTracking";
import { CargoTrackingResult as _utilities_CargoTracking_CargoTrackingResult } from "../src/pages/utilities/CargoTracking/CargoTrackingResult";
import { PrintCargoTrackingDetails as _utilities_CargoTracking_PrintCargoTrackingDetails } from "../src/pages/utilities/CargoTracking/PrintCargoTrackingDetails";
import { PrintCargoTrackingOverview as _utilities_CargoTracking_PrintCargoTrackingOverview } from "../src/pages/utilities/CargoTracking/PrintCargoTrackingOverview";
import { AddCommodity as _utilities_Commodity_AddCommodity } from "../src/pages/utilities/Commodity/AddCommodity";
import { Commodities as _utilities_Commodity_Commodities } from "../src/pages/utilities/Commodity/Commodities";
import { CommodityDetails as _utilities_Commodity_CommodityDetails } from "../src/pages/utilities/Commodity/CommodityDetails";
import { AddConsignee as _utilities_Contact_Consignees_AddConsignee } from "../src/pages/utilities/Contact/Consignees/AddConsignee";
import { ConsigneeDetails as _utilities_Contact_Consignees_ConsigneeDetails } from "../src/pages/utilities/Contact/Consignees/ConsigneeDetails";
import { Consignees as _utilities_Contact_Consignees_Consignees } from "../src/pages/utilities/Contact/Consignees/Consignees";
import { AddShipper as _utilities_Contact_Shippers_AddShipper } from "../src/pages/utilities/Contact/Shippers/AddShipper";
import { ShipperDetails as _utilities_Contact_Shippers_ShipperDetails } from "../src/pages/utilities/Contact/Shippers/ShipperDetails";
import { Shippers as _utilities_Contact_Shippers_Shippers } from "../src/pages/utilities/Contact/Shippers/Shippers";
import { Dashboard as _utilities_Dashboard } from "../src/pages/utilities/Dashboard";
import { InvitationsReceived as _utilities_Friend_InvitationsReceived } from "../src/pages/utilities/Friend/InvitationsReceived";
import { InvitationsSent as _utilities_Friend_InvitationsSent } from "../src/pages/utilities/Friend/InvitationsSent";
import { InvoiceList as _utilities_Invoice_InvoiceList } from "../src/pages/utilities/Invoice/InvoiceList";
import { Checklist as _utilities_MembershipForm_Checklist } from "../src/pages/utilities/MembershipForm/Checklist";
import { Complete as _utilities_MembershipForm_Complete } from "../src/pages/utilities/MembershipForm/Complete";
import { DelegationForm as _utilities_MembershipForm_DelegationForm } from "../src/pages/utilities/MembershipForm/DelegationForm";
import { Information as _utilities_MembershipForm_Information } from "../src/pages/utilities/MembershipForm/Information";
import { PolicyAgreement as _utilities_MembershipForm_PolicyAgreement } from "../src/pages/utilities/MembershipForm/PolicyAgreement";
import { NotificationCenter as _utilities_NotificationCenter_NotificationCenter } from "../src/pages/utilities/NotificationCenter/NotificationCenter";
import { ChineseNewYear2023 as _utilities_Notifications_ChineseNewYear2023 } from "../src/pages/utilities/Notifications/ChineseNewYear2023";
import { GoldenWeek2023 as _utilities_Notifications_GoldenWeek2023 } from "../src/pages/utilities/Notifications/GoldenWeek2023";
import { NewYear2023 as _utilities_Notifications_NewYear2023 } from "../src/pages/utilities/Notifications/NewYear2023";
import { PriceUp as _utilities_Notifications_PriceUp } from "../src/pages/utilities/Notifications/PriceUp";
import { PriceSimulator as _utilities_PriceSimulator_PriceSimulator } from "../src/pages/utilities/PriceSimulator/PriceSimulator";

export default function Chunk_default() {
  return (
    <Switch>
      <Route path="/Loading" exact>
        <_Loading />
      </Route>

      <Route path="/Maintenance" exact>
        <_Maintenance />
      </Route>

      <Route path="/NoMatch" exact>
        <_NoMatch />
      </Route>

      <Route path="/NotAuthorized" exact>
        <_NotAuthorized />
      </Route>

      <Route path="/about/AboutCompany" exact>
        <_about_AboutCompany />
      </Route>

      <Route path="/about/CookiePolicy" exact>
        <_about_CookiePolicy />
      </Route>

      <Route path="/about/PrivacyPolicy" exact>
        <_about_PrivacyPolicy />
      </Route>

      <Route path="/about/TermsOfUse" exact>
        <_about_TermsOfUse />
      </Route>

      <Route path="/admin/agency/AgencyDetails" exact>
        <_admin_agency_AgencyDetails />
      </Route>

      <Route path="/admin/agency/WarehouseCalendar" exact>
        <_admin_agency_WarehouseCalendar />
      </Route>

      <Route path="/admin/auth/ForgetPassword" exact>
        <_admin_auth_ForgetPassword />
      </Route>

      <Route path="/admin/auth/Login" exact>
        <_admin_auth_Login />
      </Route>

      <Route path="/admin/auth/ResetPassword" exact>
        <_admin_auth_ResetPassword />
      </Route>

      <Route path="/admin/booking/AllBookings" exact>
        <_admin_booking_AllBookings />
      </Route>

      <Route path="/admin/booking/BookingCreate" exact>
        <_admin_booking_BookingCreate />
      </Route>

      <Route path="/admin/booking/BookingCreateComplete" exact>
        <_admin_booking_BookingCreateComplete />
      </Route>

      <Route path="/admin/booking/BookingDetails" exact>
        <_admin_booking_BookingDetails />
      </Route>

      <Route path="/admin/booking/BookingInquiries" exact>
        <_admin_booking_BookingInquiries />
      </Route>

      <Route path="/admin/booking/CanceledBookings" exact>
        <_admin_booking_CanceledBookings />
      </Route>

      <Route path="/admin/booking/CurrentBookingsAfterDeparture" exact>
        <_admin_booking_CurrentBookingsAfterDeparture />
      </Route>

      <Route path="/admin/booking/CurrentBookingsBeforeDeparture" exact>
        <_admin_booking_CurrentBookingsBeforeDeparture />
      </Route>

      <Route path="/admin/booking/CustomsCommodityExport" exact>
        <_admin_booking_CustomsCommodityExport />
      </Route>

      <Route path="/admin/booking/CustomsInstruction" exact>
        <_admin_booking_CustomsInstruction />
      </Route>

      <Route path="/admin/booking/CustomsRequestDetails" exact>
        <_admin_booking_CustomsRequestDetails />
      </Route>

      <Route path="/admin/booking/Dashboard" exact>
        <_admin_booking_Dashboard />
      </Route>

      <Route path="/admin/booking/DeliveryInstruction" exact>
        <_admin_booking_DeliveryInstruction />
      </Route>

      <Route path="/admin/booking/DeliveryRequestDetails" exact>
        <_admin_booking_DeliveryRequestDetails />
      </Route>

      <Route path="/admin/booking/DeliveryRequests" exact>
        <_admin_booking_DeliveryRequests />
      </Route>

      <Route path="/admin/booking/ExportPreAlert" exact>
        <_admin_booking_ExportPreAlert />
      </Route>

      <Route path="/admin/booking/ExportSeaWaybill" exact>
        <_admin_booking_ExportSeaWaybill />
      </Route>

      <Route path="/admin/booking/InquiryDetails" exact>
        <_admin_booking_InquiryDetails />
      </Route>

      <Route path="/admin/booking/InvoiceDetail" exact>
        <_admin_booking_InvoiceDetail />
      </Route>

      <Route path="/admin/booking/PastBookings" exact>
        <_admin_booking_PastBookings />
      </Route>

      <Route path="/admin/booking/PaymentSlipDetails" exact>
        <_admin_booking_PaymentSlipDetails />
      </Route>

      <Route path="/admin/booking/PrintBarcode" exact>
        <_admin_booking_PrintBarcode />
      </Route>

      <Route path="/admin/booking/PrintCustomsRequestLog" exact>
        <_admin_booking_PrintCustomsRequestLog />
      </Route>

      <Route path="/admin/booking/PrintDeliveryRequestLog" exact>
        <_admin_booking_PrintDeliveryRequestLog />
      </Route>

      <Route path="/admin/booking/PrintInvoiceLog" exact>
        <_admin_booking_PrintInvoiceLog />
      </Route>

      <Route path="/admin/booking/PrintPaymentSlipLog" exact>
        <_admin_booking_PrintPaymentSlipLog />
      </Route>

      <Route path="/admin/booking/PrintPreAlertLog" exact>
        <_admin_booking_PrintPreAlertLog />
      </Route>

      <Route path="/admin/booking/PrintSeaWaybillLog" exact>
        <_admin_booking_PrintSeaWaybillLog />
      </Route>

      <Route path="/admin/invoice/InvoiceList" exact>
        <_admin_invoice_InvoiceList />
      </Route>

      <Route path="/admin/invoice/PaymentSlipBatchDetails" exact>
        <_admin_invoice_PaymentSlipBatchDetails />
      </Route>

      <Route path="/admin/invoice/PaymentSlipBatchList" exact>
        <_admin_invoice_PaymentSlipBatchList />
      </Route>

      <Route path="/admin/invoice/PaymentSlipList" exact>
        <_admin_invoice_PaymentSlipList />
      </Route>

      <Route path="/admin/members/CompletionRequests" exact>
        <_admin_members_CompletionRequests />
      </Route>

      <Route path="/admin/members/MemberDetails" exact>
        <_admin_members_MemberDetails />
      </Route>

      <Route path="/admin/members/Members" exact>
        <_admin_members_Members />
      </Route>

      <Route path="/admin/members/MembershipFormDetails" exact>
        <_admin_members_MembershipFormDetails />
      </Route>

      <Route path="/admin/members/MembershipForms" exact>
        <_admin_members_MembershipForms />
      </Route>

      <Route path="/admin/members/Users" exact>
        <_admin_members_Users />
      </Route>

      <Route path="/admin/staffs/AddStaff" exact>
        <_admin_staffs_AddStaff />
      </Route>

      <Route path="/admin/staffs/Password" exact>
        <_admin_staffs_Password />
      </Route>

      <Route path="/admin/staffs/Profile" exact>
        <_admin_staffs_Profile />
      </Route>

      <Route path="/admin/staffs/Staff" exact>
        <_admin_staffs_Staff />
      </Route>

      <Route path="/admin/staffs/Staffs" exact>
        <_admin_staffs_Staffs />
      </Route>

      <Route path="/admin/widgets/Agencies" exact>
        <_admin_widgets_Agencies />
      </Route>

      <Route path="/admin/widgets/AgencyDetails" exact>
        <_admin_widgets_AgencyDetails />
      </Route>

      <Route path="/admin/widgets/CargoTracking" exact>
        <_admin_widgets_CargoTracking />
      </Route>

      <Route path="/admin/widgets/CargoTrackingDetails" exact>
        <_admin_widgets_CargoTrackingDetails />
      </Route>

      <Route path="/admin/widgets/ExchangeCalendar" exact>
        <_admin_widgets_ExchangeCalendar />
      </Route>

      <Route path="/admin/widgets/PartnerDetails" exact>
        <_admin_widgets_PartnerDetails />
      </Route>

      <Route path="/admin/widgets/Partners" exact>
        <_admin_widgets_Partners />
      </Route>

      <Route path="/admin/widgets/RoutePlanDetail" exact>
        <_admin_widgets_RoutePlanDetail />
      </Route>

      <Route path="/admin/widgets/RoutePlanManagement" exact>
        <_admin_widgets_RoutePlanManagement />
      </Route>

      <Route path="/admin/widgets/VesselSchedule" exact>
        <_admin_widgets_VesselSchedule />
      </Route>

      <Route path="/admin/widgets/WarehouseCalendar" exact>
        <_admin_widgets_WarehouseCalendar />
      </Route>

      <Route path="/auth/ConfirmEmail" exact>
        <_auth_ConfirmEmail />
      </Route>

      <Route path="/auth/CreateAccount" exact>
        <_auth_CreateAccount />
      </Route>

      <Route path="/auth/CreateAccountVerifyEmail" exact>
        <_auth_CreateAccountVerifyEmail />
      </Route>

      <Route path="/auth/ForgetPassword" exact>
        <_auth_ForgetPassword />
      </Route>

      <Route path="/auth/Login" exact>
        <_auth_Login />
      </Route>

      <Route path="/auth/ResendEmail" exact>
        <_auth_ResendEmail />
      </Route>

      <Route path="/auth/ResetPassword" exact>
        <_auth_ResetPassword />
      </Route>

      <Route path="/dev/About" exact>
        <_dev_About />
      </Route>

      <Route path="/dev/Accounts" exact>
        <_dev_Accounts />
      </Route>

      <Route path="/dev/E2eMail" exact>
        <_dev_E2eMail />
      </Route>

      <Route path="/dev/FCProxy" exact>
        <_dev_FCProxy />
      </Route>

      <Route path="/dev/Impersonate" exact>
        <_dev_Impersonate />
      </Route>

      <Route path="/dev/MockKikan" exact>
        <_dev_MockKikan />
      </Route>

      <Route path="/dev/NextForm" exact>
        <_dev_NextForm />
      </Route>

      <Route path="/dev/Svgs" exact>
        <_dev_Svgs />
      </Route>

      <Route path="/dev/Theme" exact>
        <_dev_Theme />
      </Route>

      <Route path="/dev/Urls" exact>
        <_dev_Urls />
      </Route>

      <Route path="/dev/tests/TestBadResponse" exact>
        <_dev_tests_TestBadResponse />
      </Route>

      <Route path="/dev/tests/TestError" exact>
        <_dev_tests_TestError />
      </Route>

      <Route path="/dev/tests/TestNextBadResponse" exact>
        <_dev_tests_TestNextBadResponse />
      </Route>

      <Route path="/dev/tests/TestPost400" exact>
        <_dev_tests_TestPost400 />
      </Route>

      <Route path="/dev/tests/TestQingdaoRouteAlert" exact>
        <_dev_tests_TestQingdaoRouteAlert />
      </Route>

      <Route path="/dev/tests/TestStatusError404" exact>
        <_dev_tests_TestStatusError404 />
      </Route>

      <Route path="/dev/tests/TestStatusError500" exact>
        <_dev_tests_TestStatusError500 />
      </Route>

      <Route path="/dev/tests/TestTextBox" exact>
        <_dev_tests_TestTextBox />
      </Route>

      <Route path="/dev/tests/TestTypeError" exact>
        <_dev_tests_TestTypeError />
      </Route>

      <Route path="/external/CustomsRequestDownloadPdf" exact>
        <_external_CustomsRequestDownloadPdf />
      </Route>

      <Route path="/external/DeliveryRequestDownloadPdf" exact>
        <_external_DeliveryRequestDownloadPdf />
      </Route>

      <Route path="/external/DeliveryRequestReceiptUpload" exact>
        <_external_DeliveryRequestReceiptUpload />
      </Route>

      <Route path="/external/PrintCustomsRequestLog" exact>
        <_external_PrintCustomsRequestLog />
      </Route>

      <Route path="/external/PrintDeliveryRequestLog" exact>
        <_external_PrintDeliveryRequestLog />
      </Route>

      <Route path="/settings/AccountManager/Profile" exact>
        <_settings_AccountManager_Profile />
      </Route>

      <Route path="/settings/AccountManager/Security" exact>
        <_settings_AccountManager_Security />
      </Route>

      <Route path="/settings/Membership/Checklist" exact>
        <_settings_Membership_Checklist />
      </Route>

      <Route path="/settings/Membership/CompanyInfo" exact>
        <_settings_Membership_CompanyInfo />
      </Route>

      <Route path="/settings/Membership/DelegationForm" exact>
        <_settings_Membership_DelegationForm />
      </Route>

      <Route path="/settings/Membership/PrincipalInfo" exact>
        <_settings_Membership_PrincipalInfo />
      </Route>

      <Route path="/utilities/BlanketInsurance/AddBlanketInsurance" exact>
        <_utilities_BlanketInsurance_AddBlanketInsurance />
      </Route>

      <Route path="/utilities/BlanketInsurance/BlanketInsuranceDetails" exact>
        <_utilities_BlanketInsurance_BlanketInsuranceDetails />
      </Route>

      <Route path="/utilities/BlanketInsurance/BlanketInsurances" exact>
        <_utilities_BlanketInsurance_BlanketInsurances />
      </Route>

      <Route path="/utilities/BookingInquiry/Complete" exact>
        <_utilities_BookingInquiry_Complete />
      </Route>

      <Route path="/utilities/BookingInquiry/InquiryForm" exact>
        <_utilities_BookingInquiry_InquiryForm />
      </Route>

      <Route path="/utilities/BookingInquiry/MobileCautions" exact>
        <_utilities_BookingInquiry_MobileCautions />
      </Route>

      <Route path="/utilities/Bookings/BookingInquiryHistory" exact>
        <_utilities_Bookings_BookingInquiryHistory />
      </Route>

      <Route path="/utilities/Bookings/BookingInquiryHistoryDetails" exact>
        <_utilities_Bookings_BookingInquiryHistoryDetails />
      </Route>

      <Route path="/utilities/Bookings/BookingInquiryLogs" exact>
        <_utilities_Bookings_BookingInquiryLogs />
      </Route>

      <Route path="/utilities/Bookings/CurrentBookingDetails" exact>
        <_utilities_Bookings_CurrentBookingDetails />
      </Route>

      <Route path="/utilities/Bookings/CurrentBookings" exact>
        <_utilities_Bookings_CurrentBookings />
      </Route>

      <Route path="/utilities/Bookings/CustomsInstruction" exact>
        <_utilities_Bookings_CustomsInstruction />
      </Route>

      <Route path="/utilities/Bookings/CustomsInstructionList" exact>
        <_utilities_Bookings_CustomsInstructionList />
      </Route>

      <Route path="/utilities/Bookings/DeliveryGuidance" exact>
        <_utilities_Bookings_DeliveryGuidance />
      </Route>

      <Route path="/utilities/Bookings/DeliveryInstruction" exact>
        <_utilities_Bookings_DeliveryInstruction />
      </Route>

      <Route path="/utilities/Bookings/DeliveryInstructionList" exact>
        <_utilities_Bookings_DeliveryInstructionList />
      </Route>

      <Route path="/utilities/Bookings/ExportArrivalNotice" exact>
        <_utilities_Bookings_ExportArrivalNotice />
      </Route>

      <Route path="/utilities/Bookings/ExportPreAlert" exact>
        <_utilities_Bookings_ExportPreAlert />
      </Route>

      <Route path="/utilities/Bookings/ExportSeaWaybill" exact>
        <_utilities_Bookings_ExportSeaWaybill />
      </Route>

      <Route path="/utilities/Bookings/PastBookingDetails" exact>
        <_utilities_Bookings_PastBookingDetails />
      </Route>

      <Route path="/utilities/Bookings/PastBookings" exact>
        <_utilities_Bookings_PastBookings />
      </Route>

      <Route path="/utilities/Bookings/PrintArrivalNoticeLogs" exact>
        <_utilities_Bookings_PrintArrivalNoticeLogs />
      </Route>

      <Route path="/utilities/Bookings/PrintBarcode" exact>
        <_utilities_Bookings_PrintBarcode />
      </Route>

      <Route path="/utilities/Bookings/PrintCurrentBookingDetails" exact>
        <_utilities_Bookings_PrintCurrentBookingDetails />
      </Route>

      <Route path="/utilities/Bookings/PrintPreAlertLog" exact>
        <_utilities_Bookings_PrintPreAlertLog />
      </Route>

      <Route path="/utilities/Bookings/PrintSeaWaybillLog" exact>
        <_utilities_Bookings_PrintSeaWaybillLog />
      </Route>

      <Route path="/utilities/CargoTracking/CargoTracking" exact>
        <_utilities_CargoTracking_CargoTracking />
      </Route>

      <Route path="/utilities/CargoTracking/CargoTrackingResult" exact>
        <_utilities_CargoTracking_CargoTrackingResult />
      </Route>

      <Route path="/utilities/CargoTracking/PrintCargoTrackingDetails" exact>
        <_utilities_CargoTracking_PrintCargoTrackingDetails />
      </Route>

      <Route path="/utilities/CargoTracking/PrintCargoTrackingOverview" exact>
        <_utilities_CargoTracking_PrintCargoTrackingOverview />
      </Route>

      <Route path="/utilities/Commodity/AddCommodity" exact>
        <_utilities_Commodity_AddCommodity />
      </Route>

      <Route path="/utilities/Commodity/Commodities" exact>
        <_utilities_Commodity_Commodities />
      </Route>

      <Route path="/utilities/Commodity/CommodityDetails" exact>
        <_utilities_Commodity_CommodityDetails />
      </Route>

      <Route path="/utilities/Contact/Consignees/AddConsignee" exact>
        <_utilities_Contact_Consignees_AddConsignee />
      </Route>

      <Route path="/utilities/Contact/Consignees/ConsigneeDetails" exact>
        <_utilities_Contact_Consignees_ConsigneeDetails />
      </Route>

      <Route path="/utilities/Contact/Consignees/Consignees" exact>
        <_utilities_Contact_Consignees_Consignees />
      </Route>

      <Route path="/utilities/Contact/Shippers/AddShipper" exact>
        <_utilities_Contact_Shippers_AddShipper />
      </Route>

      <Route path="/utilities/Contact/Shippers/ShipperDetails" exact>
        <_utilities_Contact_Shippers_ShipperDetails />
      </Route>

      <Route path="/utilities/Contact/Shippers/Shippers" exact>
        <_utilities_Contact_Shippers_Shippers />
      </Route>

      <Route path="/utilities/Dashboard" exact>
        <_utilities_Dashboard />
      </Route>

      <Route path="/utilities/Friend/InvitationsReceived" exact>
        <_utilities_Friend_InvitationsReceived />
      </Route>

      <Route path="/utilities/Friend/InvitationsSent" exact>
        <_utilities_Friend_InvitationsSent />
      </Route>

      <Route path="/utilities/Invoice/InvoiceList" exact>
        <_utilities_Invoice_InvoiceList />
      </Route>

      <Route path="/utilities/MembershipForm/Checklist" exact>
        <_utilities_MembershipForm_Checklist />
      </Route>

      <Route path="/utilities/MembershipForm/Complete" exact>
        <_utilities_MembershipForm_Complete />
      </Route>

      <Route path="/utilities/MembershipForm/DelegationForm" exact>
        <_utilities_MembershipForm_DelegationForm />
      </Route>

      <Route path="/utilities/MembershipForm/Information" exact>
        <_utilities_MembershipForm_Information />
      </Route>

      <Route path="/utilities/MembershipForm/PolicyAgreement" exact>
        <_utilities_MembershipForm_PolicyAgreement />
      </Route>

      <Route path="/utilities/NotificationCenter/NotificationCenter" exact>
        <_utilities_NotificationCenter_NotificationCenter />
      </Route>

      <Route path="/utilities/Notifications/ChineseNewYear2023" exact>
        <_utilities_Notifications_ChineseNewYear2023 />
      </Route>

      <Route path="/utilities/Notifications/GoldenWeek2023" exact>
        <_utilities_Notifications_GoldenWeek2023 />
      </Route>

      <Route path="/utilities/Notifications/NewYear2023" exact>
        <_utilities_Notifications_NewYear2023 />
      </Route>

      <Route path="/utilities/Notifications/PriceUp" exact>
        <_utilities_Notifications_PriceUp />
      </Route>

      <Route path="/utilities/PriceSimulator/PriceSimulator" exact>
        <_utilities_PriceSimulator_PriceSimulator />
      </Route>

      <Route path="*">
        <NoMatch />
      </Route>
    </Switch>
  );
}
